import { jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment, useEffect, useRef } from 'react';
import UIOverlay from '../UIComponents/UIOverlay';
import PreviewDisabled from '../Common/PreviewDisabled';
export default function PreviewForm({ url, fullSiteEditor }) {
    const inputEl = useRef(null);
    useEffect(() => {
        if (inputEl.current) {
            //@ts-expect-error Hubspot global
            const hbspt = window.parent.hbspt || window.hbspt;
            hbspt.meetings.create('.meetings-iframe-container');
        }
    }, [url, inputEl]);
    if (fullSiteEditor) {
        return _jsx(PreviewDisabled, {});
    }
    return (_jsx(Fragment, { children: url && (_jsx(UIOverlay, { ref: inputEl, className: "meetings-iframe-container", "data-src": `${url}?embed=true` })) }));
}
